<template>
    <ElImageViewer v-if="showViewer" :on-close="closeViewer" :urlList="urlList" :z-index="zIndex"></ElImageViewer>
  </template>
  
  <script>
  import ElImageViewer from 'element-ui/packages/image/src/image-viewer'
  export default {
      components:{
          ElImageViewer
      },
      data() {
          return {
              showViewer:false,
              urlList:[],
              zIndex:3000,
          }
      },
      methods: {
          closeViewer(){
              this.showViewer = false;
              this.urlList = [];
          },
      }
  }
  </script>
  